import { NgModule } from '@angular/core';
import { ModalConfirmDirective } from './confirm.directive';
import { ModalPromptDirective } from './prompt.directive';

@NgModule({
    imports: [
    ],
    declarations: [
        ModalPromptDirective,
        ModalConfirmDirective,
    ],
    exports: [
        ModalPromptDirective,
        ModalConfirmDirective,
    ],
})
export class ModalsDirectivesModule {}
